import styled, { createGlobalStyle } from 'styled-components';
import { colorGrayLighter, colorOffWhite, colorWhite } from '/imports/ui/stylesheets/styled-components/palette';

const TldrawV2GlobalStyle = createGlobalStyle`
  /* Override tldraw canvas background — pure white for clean tutoring canvas */
  .tl-theme__light {
    --color-background: #FFFFFF !important;
  }

  ${'' /* ${({ isPresenter, hasWBAccess,isModerator }) => (!isPresenter && !isModerator  && hasWBAccess) && `
    [data-testid="tools.hand"] {
      display: none !important;
    }
  `} */}

   ${'' /* ${({ isPresenter }) => (!isPresenter) && `
    [data-testid="tools.hand"] {
      display: none !important;
    }
  `} */}

  ${({ isMultiUserActive }) => !isMultiUserActive && `
    ${'' /* .tl-nametag {
      display: none;
    } */}
  `}
  .tl-image{
    background-size : 100% 100%;
    background-repeat : no-repeat;
  }
  ${({ isToolbarVisible }) => (!isToolbarVisible) && `
    .tlui-toolbar,
    .tlui-style-panel__wrapper {
      visibility: hidden;
    }
    #WhiteboardOptionButton {
      opacity: 0.2;
    }
  `}

  .tl-canvas {
    touch-action: none !important;
  }

  #whiteboard-element {
    touch-action: none;
    position: relative;
    height: 100%;
  }

  #whiteboard-element > * {
    position: relative; 
    height: 100%;
  }

  #whiteboard-element .tl-overlays {
    left: 0px;
    bottom: 0px;
  }

  .tlui-navigation-zone,
  .tlui-help-menu,
  .tlui-debug-panel {
    display: none !important;
  }

  .tl-container:focus-within {
    outline: none !important;
  }

  .tlui-style-panel__wrapper {
    right: 0px;
    top: -0.35rem;
    position: relative;
  }

  .tl-overlays__item {
    height: auto !important;
    width: auto !important;
  }

  .tlui-popover__content {
    left: -50px !important;
  }

  ${({ isPresenter, isMultiUserActive }) => !isPresenter && !isMultiUserActive && `
    .tl-cursor use {
      transform: scale(0.05)!important;
    }

    .tl-collaborator__cursor {
      position: absolute !important;
      left: -7px !important;
      top: -6px !important;
    }
  `}

  .tlui-toolbar__extras {
    position: fixed !important;
    top: 2px !important;
    
  }

  .tlui-toolbar__extras__controls {
    border-radius: var(--radius-4);
    border: none;
    background-color: ${colorOffWhite};
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.16),
      0px 2px 3px rgba(0, 0, 0, 0.24),
      0px 2px 6px rgba(0, 0, 0, 0.1);
  }

  ${({ isRTL }) => (!isRTL) && `
    .tlui-toolbar__extras {
      right: 0;
      left: 50px !important;
    }
  `}
${({ isDesktop }) => (isDesktop) && `
     [data-testid="menu-item.paste"]{
      ${'' /* display : none!important; */}
     }
  `}

  ${({ isDesktop, bgSelected }) => (isDesktop && bgSelected) && ` 
  [data-testid="menu-item.paste"] {
    ${'' /* display: none !important; */}
  }
`}
  ${({ isRTL }) => (isRTL) && `
    .tlui-toolbar__extras {
      right: 50px !important;
      left: 0;
    }

    .tlui-toolbar__extras__controls {
      margin-right: 8px;
      margin-left: 0;
    }
  `}
  ${'' /* [data-testid="menu-item.paste"], */}
  [data-testid="menu-item.copy"],
   [data-testid="menu-item.cut"],
   [data-testid="menu-item.edit-link"]
  {
      display: none !important;
  }
  ${({ bgSelected,boundarySelected }) => (bgSelected || boundarySelected) && `
      [data-testid="menu-item.toggle-lock"],
      [data-testid="menu-item.toggle-locked"],
      ${'' /* [data-testid="menu-item.paste"], */}
      [data-testid="menu-item.copy"] {
        display: none !important;
      }
  `}

  /* Ensure highlights always render above slide images */
${'' /* .tl-shape[data-shape-type="highlight"] {
  z-index: 5000 !important;
} */}
[data-testid="main.action-menu"]{
  display:none!important;
}
  [data-testid="menu-item.bring-to-front"],
  [data-testid="menu-item.bring-forward"],
  [data-testid="menu-item.send-backward"],
  [data-testid="menu-item.send-to-back"],
  [data-testid="menu-item.modify"],
  [data-testid="menu-item.conversions"],
  .tlui-helper-buttons,
  [data-testid="main.page-menu"],
  [data-testid="main.menu"],
  [data-testid="tools.more.laser"],
  [data-testid="tools.more.frame"],
  ${'' /* [data-testid="tools.asset"], */}
  [data-testid="page-menu.button"],
  [data-testid="menu-item.zoom-to-100"],
  
  .tlui-menu-zone {
    display: none !important;
  }

  .tl-collaborator__cursor {
    height: auto !important
    width: auto !important;
  }

  .tlui-layout__mobile .tlui-button__tool {
    height: 40px !important;
    width: 48px !important;
  }

  .tlui-toolbar__inner {
    flex-direction: column-reverse !important;
  }

  .tlui-toolbar__tools {
    flex-direction: column !important;
  }
  .tlui-button[data-testid="tools.more"] {
    border-top : 1px solid ${colorGrayLighter};
    margin-left : 0px;
  }
  .tlui-toolbar {
    align-items: end !important;
  }
  .tlui-button{
    text-shadow:none!important;
  }
  .tlui-layout__bottom {
    grid-row: auto / auto !important;
    position: absolute !important;
    right: 20px !important;
    --tlui-layout-bottom-top: 0px;
  }


  .tl-text-input {
  animation: none !important;
  transition: none !important;
  background: transparent !important;
}

  [data-side="bottom"][data-align="end"][data-state="open"][role="dialog"] {
    right: 3.5rem !important;
    bottom: 9.5rem !important;
  }

  [id*="shape:poll-result"] {
    background-color: white !important;
  }

  [data-testid="tools.delete-all"] {
    display: flex;
  }

  ${({ presentationHeight }) => {
    const minRange = { height: 345, top: 0 };
    const maxRange = { height: 1200, top: 384 };

    const interpolateTop = (height) => {
      if (height <= minRange.height) return `${minRange.top}px`;
      if (height >= maxRange.height) return `${maxRange.top}px`;

      const slope = (maxRange.top - minRange.top) / (maxRange.height - minRange.height);
      const interpolatedTop = minRange.top + slope * (height - minRange.height);
      return `${interpolatedTop}px`;
    };

    const topValue = interpolateTop(presentationHeight);

    let additionalStyles = '';
    if (presentationHeight <= 500) {
      additionalStyles += `
        .tlui-layout__mobile .tlui-button__tool > .tlui-icon {
          ${'' /* height: 10px !important;
          width: 10px !important; */}
        }

        .tlui-toolbar__tools {
          flex-direction: row !important;
        }

        .tlui-toolbar__inner {
          flex-direction: row-reverse !important;
        }

        .tlui-layout__bottom {
          grid-row: auto / auto !important;
          position: relative !important;
          top: 2px !important;
          --tlui-layout-bottom-top: 2px;
        }

        .tlui-toolbar__tools.tlui-toolbar__tools__mobile.fade-in {
          ${'' /* height: 30px !important; */}
        }
        .tlui-button[data-testid="tools.more"] {
            border-left : 1px solid #2d2d2d;
            border-top:none;
          }
        [data-side="top"][role="dialog"]:has(.tlui-style-panel) {
          left: 10rem !important;
        }
      `;
    }
    if (presentationHeight <= 690) {
      additionalStyles += `.tlui-layout__mobile .tlui-button__tool {
          height: 30px !important;
          width: 38px !important;
      }`
    }
    // Always include this:
    additionalStyles += `
      .tlui-button__tool[data-state='selected']:not(:disabled)::after {
        background: #00265D;
        opacity: 1 !important;
      }
`;
    return `.tlui-layout__bottom { 
      top: ${topValue} !important; 
      --tlui-layout-bottom-top: ${topValue};
    }${additionalStyles}`;
  }}
  [data-darkreader-scheme="dark"] button[data-testid="mobile.styles"] {
    & > div.tlui-icon {
      color: ${colorWhite};
    }
  }

    ${({ cursorType }) => (cursorType) && `
      .tl-canvas {
        cursor: ${cursorType} !important;
      }
  `}

`;

const EditableWBWrapper = styled.div`
  &, & > :first-child {
    cursor: inherit !important;
  }
`;

export default {
  TldrawV2GlobalStyle,
  EditableWBWrapper,
};
